/* eslint-disable filenames/match-exported */
import history, { setAppContext } from './src/history';

export default history;
export { setAppContext };
